/**
 * ReTechler official logo, vectorised as transparent-background SVG.
 *
 * The SVG was traced from the master brand mark so it renders pixel-sharp
 * at every size and sits on any background colour (transparent).
 */

export default function Logo({ height = 40, className = "", title = "ReTechler" }) {
    return (
        <img
            src="/logo.svg"
            alt={title}
            style={{ height: `${height}px`, width: "auto" }}
            className={`block select-none ${className}`}
            draggable={false}
        />
    );
}
